import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App.jsx";
import "./assets/fonts/CoolBritannia-Sans.otf";
import { IosZoom } from "./components";
import logger from "./utils/logger";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then(
      (registration) => {
        logger.info("ServiceWorker registration successful with scope: ", registration.scope);
      },
      (error) => {
        logger.info("ServiceWorker registration failed: ", error);
      }
    );
  });
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <IosZoom />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
